<template>
    <div class="create-company-page page" style="max-width: 600px">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title" v-if="user">
                        {{ user.name }}
                    </h4>
                </div>
            </div>
        </div>
        <div class="card card-body mt-0">
            <div v-if="!user">Loading...</div>
            <user :user="user" v-else/>
        </div>
    </div>
</template>

<script>
    import User from "@/components/main/User";
    import UserModel from "@/models/user";

    export default {
        components: {
            User
        },
        data() {
            return {
                user: null
            }
        },
        created() {
            this.initUser()
        },
        methods: {
            initUser() {
                UserModel.include(
                    'roles'
                )
                    .find(this.$route.params.id)
                    .then((response) => {
                        this.user = response;
                    });
            }
        }
    }
</script>

<style scoped>

</style>
